import React, { memo, useCallback } from 'react';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import {
  NonExtendedConditionObjectType,
  IValue,
} from '../../../../../../../Types/UrvalTypes';
import { append, remove } from 'ramda';
import shortid from 'shortid';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';
import { setValues } from '../../../Utils/UrvalValueConditionObjectUtils';

interface IProps {
  conditionObject: NonExtendedConditionObjectType;
  setConditionObject: (
    newConditionObject: NonExtendedConditionObjectType
  ) => void;
  deleteConditionObject: () => void;
  index?: number;
  showAddButton?: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignSelf: 'start',
  },
  valueConditionValuesControl: {},
  hidden: {
    visibility: 'hidden',
  },
  deleteButtonMargin: {
    marginRight: 48,
  },
});

const ConditionValuesControls: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const { setConditionObject } = props;
  const onAdd = useCallback(() => {
    if (
      props.conditionObject.type === 'String' ||
      props.conditionObject.type === 'Numeric'
    ) {
      const newValues = append<IValue>(
        { id: shortid.generate() },
        props.conditionObject.condition[0].values
      );

      setConditionObject(setValues(newValues, props.conditionObject));
    }
  }, [props.conditionObject, setConditionObject]);

  const onRemove = useCallback(() => {
    const { conditionObject, setConditionObject, deleteConditionObject } =
      props;
    if (
      conditionObject.type === 'String' ||
      conditionObject.type === 'Numeric'
    ) {
      const newValues = remove(
        props.index !== undefined
          ? props.index
          : conditionObject.condition[0].values.length - 1,
        1,
        conditionObject.condition[0].values
      );
      if (newValues.length === 0) {
        deleteConditionObject();
      } else {
        setConditionObject(setValues(newValues, conditionObject));
      }
    } else {
      deleteConditionObject();
    }
  }, [props]);

  const { classes, conditionObject } = props;

  const isValueCondition =
    conditionObject.type === 'String' || conditionObject.type === 'Numeric';

  const delConditionOnClick = isValueCondition
    ? conditionObject.condition[0].values.length < 2
    : true;

  return (
    <div
      className={classNames(props.classes.root, {
        [classes.valueConditionValuesControl]: isValueCondition,
      })}
    >
      <EDIconButton
        color="inherit"
        margin="none"
        icon="remove_circle_outlined"
        onClick={onRemove}
        tooltip={
          delConditionOnClick
            ? `Ta bort ${conditionObject.attribute.DisplayLabel}`
            : 'Ta bort värde'
        }
        className={classNames({
          [props.classes.deleteButtonMargin]: !props.showAddButton,
        })}
      />
      {props.showAddButton && (
        <EDIconButton
          color="inherit"
          margin="none"
          icon="add_circle_outlined"
          onClick={onAdd}
          tooltip={!isValueCondition ? '' : 'Lägg till värde'}
          className={classNames({ [classes.hidden]: !isValueCondition })}
        />
      )}
    </div>
  );
};

export default withStyles(memo(ConditionValuesControls), styles);
